import React, { forwardRef } from 'react';
import { ChevronUp, ChevronDown } from './Icons';
import '../i18n';
import { useTranslation } from 'react-i18next';
import withClickOutside from './withClickOutside';
import { ArrowUp } from './Icons';
import { useMediaQuery } from '../helpers';

const Footer = forwardRef(({ open, setOpen, props }, ref) => {
    const { t, i18n } = useTranslation();

    // @media property
    const isMobile = useMediaQuery('screen and (max-width: 680px)');

    const topFunction = () => {
        const node = document.querySelectorAll('.card-style')[0];
        const height = '250px';
        node.scrollIntoView(true);
        const scrolledY = window.scrollY;

        if (scrolledY) {
            window.scroll(0, scrolledY - height);
        }
    }

    return (
        <footer className={`flex py-2 relative ${!isMobile ? 'px-9 justify-between' : 'px-3'}`} ref={ref}>
            <div className="flex relative" style={{ width: '70px' }}>
                <div className="text-ed-grey text-sm pr-1">{t(i18n.resolvedLanguage)}</div>
                <span
                    className="flex items-center justify-center cursor-pointer"
                    onClick={() => setOpen(!open)}
                >
                    {
                        !open ? (
                            <ChevronUp width="10px" height="10px" color="#868D96" />
                        ) : (<ChevronDown width="10px" height="10px" color="#868D96" />)
                    }
                </span>
                {open && (
                    <React.Fragment>
                        <ul className="dropdown-container absolute p-2">
                            {
                                Object.keys(i18n.services.resourceStore.data)
                                    .filter(lang => lang !== i18n.resolvedLanguage)
                                    .map(filteredLang => (
                                        <li
                                            className="cursor-pointer text-sm"
                                            onClick={() => { i18n.changeLanguage(filteredLang); setOpen(!open) }}
                                        >
                                            {t(filteredLang)}
                                        </li>
                                    ))
                            }
                        </ul>
                        <div className="icon-arrow-down "></div>
                    </React.Fragment>
                )}
            </div>
            <div className={`text-sm text-ed-grey flex w-full ${isMobile ? 'justify-end' : 'justify-center'}`}>{t('disclaimer')}</div>
            <div style={{ width: !isMobile ? '70px' : '' }}></div>
            {!isMobile && (<div
                className="scroll-on-top-arrow absolute cursor-pointer"
                onClick={topFunction}
                style={{ backgroundColor: props.settings.items_color ||  props.settings.organization_items_color || '#FF585D' }}
            >
                <ArrowUp width="60px" height="30px" color="#fff" />
            </div>)}
        </footer>
    )
});

export default withClickOutside(Footer);